<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.params.type==1" :to="{ name: 'Factory' }">厂家列表</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ name: 'Producer' }">板商列表</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.params.type==1" :to="{ name: 'EditFactory',params:{innerid:$route.params.related} }">编辑厂家</el-breadcrumb-item>
          <el-breadcrumb-item v-else :to="{ name: 'EditProducer',params:{innerid:$route.params.related} }">编辑板商</el-breadcrumb-item>
          <el-breadcrumb-item>协议组合</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          当前编辑{{ title }}<span></span>
        </el-row>
          <el-divider></el-divider>
          <el-row style="color:#666666;font-size: 14px;">
            <el-col :offset="1" :span="22">{{protocol.factoryname}}</el-col>
          </el-row>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          基础参数配置<span></span>
        </el-row>
          <el-divider></el-divider>
          <el-form
          :model="protocol"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          style="padding-top:0px !important"
          size="mini"
        >
        <el-row>
          <el-col :span="11">
             <el-form-item label="协议名称" prop="name">
            <el-input size="small"  v-model="protocol.name" maxlength="64"></el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
             <el-form-item label="协议名称（英文）" prop="name_en">
            <el-input size="small"  v-model="protocol.name_en" maxlength="20"></el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
             <el-form-item label="默认项目名称" prop="projectname">
            <el-input size="small" v-model="protocol.projectname" maxlength="20"></el-input>
          </el-form-item>
          </el-col>
        </el-row>
         <el-row>
              <el-col :span="6">
            <el-form-item label="协议专属标志" prop="protflag">
            <el-input size="small" style="max-width:215px" v-model="protocol.protflag" maxlength="30" placeholder="协议专属标志，请勿随意更改"></el-input>
          </el-form-item>
              </el-col>
              <el-col :span="12">
            <el-form-item label="第2路485作为从站使用" >
              <el-select
         size="small"
          v-model="protocol.uart2.mode">
          <el-option  label="是" value="slave" ></el-option>
          <el-option  label="否" value="master" ></el-option>
          </el-select>
          </el-form-item>
              </el-col>
          </el-row>
        <el-row>
          <el-col :span="6">
           <el-form-item label="波特率">
            <el-select
         size="small"
          v-model="protocol.uart1.baud">
          <el-option  label="600" value="600" ></el-option>
          <el-option  label="1200" value="1200" ></el-option>
          <el-option  label="3600" value="3600" ></el-option>
          <el-option  label="4800" value="4800" ></el-option> 
          <el-option  label="7200" value="7200" ></el-option> 
          <el-option  label="9600" value="9600" ></el-option>
          <el-option  label="14400" value="14400" ></el-option>
          <el-option  label="19200" value="19200" ></el-option>
          <el-option  label="28800" value="28800" ></el-option>
          <el-option  label="38400" value="38400" ></el-option>
          <el-option  label="57600" value="57600" ></el-option>
          <el-option  label="115200" value="115200" ></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="11">
           <el-form-item label="第2路485从站波特率" >
            <el-select
         size="small"
          v-model="protocol.uart2.baud">
          <el-option  label="600" value="600" ></el-option>
          <el-option  label="1200" value="1200" ></el-option>
          <el-option  label="3600" value="3600" ></el-option>
          <el-option  label="4800" value="4800" ></el-option> 
          <el-option  label="7200" value="7200" ></el-option> 
          <el-option  label="9600" value="9600" ></el-option>
          <el-option  label="14400" value="14400" ></el-option>
          <el-option  label="19200" value="19200" ></el-option>
          <el-option  label="28800" value="28800" ></el-option>
          <el-option  label="38400" value="38400" ></el-option>
          <el-option  label="57600" value="57600" ></el-option>
          <el-option  label="115200" value="115200" ></el-option>
          </el-select>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
              <el-col :span="6">
            <el-form-item label="奇偶校验" >
              <el-select
         size="small"
          v-model="protocol.uart1.parity">
          <el-option  label="无校验" value="N" ></el-option>
          <el-option  label="偶校验" value="E" ></el-option>
          <el-option  label="奇校验" value="O" ></el-option>
          </el-select>
          </el-form-item>
              </el-col>
              <el-col :span="11">
            <el-form-item label="第2路485从站奇偶校验" >
              <el-select
         size="small"
          v-model="protocol.uart2.parity">
          <el-option  label="无校验" value="N" ></el-option>
          <el-option  label="偶校验" value="E" ></el-option>
          <el-option  label="奇校验" value="O" ></el-option>
          </el-select>
          </el-form-item>
              </el-col>
            </el-row>
          <el-row>
              <el-col :span="6">
            <el-form-item label="停止位">
              <el-select
         size="small"
          v-model="protocol.uart1.stop">
          <el-option  label="1" value="1" ></el-option>
          <el-option  label="2" value="2" ></el-option>
          </el-select>
          </el-form-item>
              </el-col>
              <el-col :span="11">
            <el-form-item label="第2路485从站停止位">
              <el-select
         size="small"
          v-model="protocol.uart2.stop">
          <el-option  label="1" value="1" ></el-option>
          <el-option  label="2" value="2" ></el-option>
          </el-select>
          </el-form-item>
              </el-col>
            </el-row>
        </el-form>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          协议组合配置<span></span>
        </el-row>
          <el-divider></el-divider>
    <el-row style="padding: 30px">
      <el-table
          border
          :data="protocol.detail"
          style="font-size: 12px"
          :header-cell-style="{
            'text-align': 'center',
            background: '#85a4e9',
            color: '#fff',
          }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
        <el-table-column label="序号" type="index">
          </el-table-column>
          <el-table-column label="协议">
            <template slot-scope="scope">
              <el-select size="small" @change="changeProtocol()" v-model="scope.row.protocolid" placeholder="请选择">
                <el-option v-for="p in protocols" :label="p.desc" :value="p.innerid" :key="p.innerid"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="设备默认名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="small"  maxlength="20"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="通讯端口">
            <template slot-scope="scope">
              <el-select size="small" v-model="scope.row.com" placeholder="请选择">
                <el-option label="A1B1" value="A1B1"> </el-option>
                <el-option label="A2B2" value="A2B2"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="从站地址">
            <template slot-scope="scope">
              <el-select size="small" v-model="scope.row.address" filterable placeholder="请选择">
                <el-option v-for="i in 255" :key="i" :label="i" :value="i"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
            <el-button style="font-size: 12px" type="text"  @click="delRow(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="text"
          class="el-icon-plus"
          style="
            width: 100%;
            border: 1px solid #ebeef5;
            border-top: 0;
            height: 40px;
            line-height: 40px;
            background-color: #fff;
          "
          @click="newRow()"
          >新增一行</el-button
        >
    </el-row>
          <el-divider></el-divider>
          <el-row style="margin-bottom: 10px;text-align: center;">
            <el-button  type="success" @click="save()">保存</el-button>
            <el-button  type="info" @click="$router.back()">返回</el-button>
          </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'createRole',
  data () {
    return {
      title:this.$route.params.type==1?'厂家':'板商',
      protocol:{name:'',
      factoryname:"",
      name_en:'',
      projectname:'',
      protflag:'',
      uart1:{"mode":"master","baud":"9600","parity":"N","stop":"1"},
      uart2:{"mode":"master","baud":"9600","parity":"N","stop":"1","slaveid":1,"slavemd":2},
      detail:[]
    },
    rules: {
        name: [{ required: true, message: '请输入协议名称', trigger: 'blur' }],
        projectname: [{ required: true, message: '请输入项目名称', trigger: 'blur' }]
      },
      protocols:[]
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      if(this.$route.params.related&&this.$route.params.type){
        Vue.axios
        .post(this.$route.params.type==1?'/factory/query':'/producer/query', {
          innerid: this.$route.params.related
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.protocol.factoryname = res.data.msgbody.name
          }
        })
        Vue.axios
        .post(this.$route.params.type==1?'/factory/protocol/all':'/producer/protocol/all', {
          set: 0,
          factoryid: this.$route.params.related,
          producerid: this.$route.params.related
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.protocols = res.data.msgbody
          }
        })
        if(this.$route.params.innerid){
        Vue.axios
          .post(this.$route.params.type==1?'/factory/protocol/cust/query':'/producer/protocol/cust/query', {
            innerid: this.$route.params.innerid
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.protocol=JSON.parse(res.data.msgbody.original)
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || this.$t("base.systemError"),
                type: 'error'
              })
            }
          })
       }
      }else{
        this.$message({
        message: '页面初始化失败，请重新进入',
        type: 'error'
      })
      }       
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    save(){
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          let url=this.$route.params.type==1?'/factory/protocol/set/add':'/producer/protocol/set/add'
          if(this.$route.params.innerid){
            self.protocol.innerid=this.$route.params.innerid
            url=this.$route.params.type==1?'/factory/protocol/set/edit':'/producer/protocol/set/edit'
          }
          self.protocol.related=this.$route.params.related
          // debugger;
          Vue.axios
            .post(url,
              self.protocol
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
                self.disabled = false
              }
            })
        } else {
          return false
        }
      })
    },
    newRow(){
      if(this.protocol.detail.length>=32){
        this.$message({
                  showClose: true,
                  message: '可添加的协议设备达到上限，请删除一个设备后，再次添加。',
                  type: 'error'
                })
        return
      }
      this.protocol.detail.push({innerid:this.Common.newGuid(),protocolid:null,name:null,com:'A1B1',address:1})
    },
    changeProtocol(){
      let ps=Array.from(new Set(this.protocol.detail.map(i=>{return i.protocolid})))
      if(ps.length>5){
        this.$message({
                  showClose: true,
                  message: '组合协议至多仅能组合5种不同的协议，请删除或修改协议。',
                  type: 'error'
                })
      }
    },
    delRow:function(row){
      let index= this.protocol.detail.findIndex(item=>{return item.innerid==row.innerid})
      if(index>-1){
        this.protocol.detail.splice(index,1) 
      }
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.x-spreadsheet-sheet,
.x-spreadsheet-overlayer,
.x-spreadsheet-toolbar{
  width:100% !important;
  padding:0;
  max-height:700px;
}

.x-spreadsheet-scrollbar.vertical{
  height:700px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Protocol/Set.vue